export default {
  // 模块名称
  realTimeAlarm: {
    // 按钮类
    button: {
      save: 'Save',
      reset: 'Reset',
      conform: 'Confirm',
      cancel: 'Cancel',
      prompt: 'Prompt',
      whole: 'All'
    },
    // 文字标签类
    label: {
      alarmLevel: 'Level',
      area: 'Area',
      description: 'Description',
      alarmName: 'Name',
      alarmType: 'Type',
      realTimeVideo: 'Live video',
      historyVideo: 'Video playback',
      videoUrl: 'Upload video',
      reportPersonName: 'Personnel',
      alarmTime: 'Alarm time',
      groupName: 'Location',
      ip: 'Alarm IP',
      desc: 'Description',
      scan: 'Live browsing',
      play: 'Playback',
      conDevice: 'Configuring linkage device',
      deviceName: 'Device name',
      location: 'Location',
      bility: 'Ability',
      mail: 'Meter',
      operation: 'operation',
      unlink: 'Unlink',
      fmeters: '5 meters',
      tmeters: '5-10 meters',
      twlmeters: '10-20 meters',
      twlemeters: '20-30 meters',
      feemeters: '30-50 meters',
      onemeters: '50-100 meters',
      choiceGroup: 'Select group',
      assign: 'Assign',
      doPerson: 'executive',
      user: 'Account name',
      fastUp: 'The alarm is sent quickly.',
      allTypes: 'All types',
      watch: 'View',
      noDatas: 'No',
      resShow: 'Resources show',
      chooseDev: 'Please select a device',
      chooseArea: 'Please select area',
      mapPic: 'Map layer',
      indoor: 'indoor',
      outdoor: 'outdoor',
      choose: 'choose',
      export: 'Export',
      onefloor: 'Second',
      tfloor: 'Third'
    },
    // 提示类
    placeholder: {
      please: 'please choose',
      input: 'please input',
      startTime: 'StartTime',
      endTime: 'EndTime'
    },
    // 消息类
    message: {
      confirmSuc: 'Submitted successfully',
      disableSet:
        'This alarm is not associated with related equipment, can not set linkage rules!',
      queryFailed: 'Query failed!',
      enterDesc: 'Please enter processing description',
      length: 'The length is between 10 and 200 characters',
      setRules:
        'This alarm is not associated with related equipment, can not set linkage rules!',
      cancelWarn: 'Do you want to cancel selected device?',
      cancelOk: 'Cancel success',
      listNull: 'The linkage rule alarm event type list is empty!',
      doListNull: 'The linkage rule linkage action list is empty!',
      countLen: 'The number of linkage devices cannot exceed 20!',
      configuration: 'Configuration successful!',
      alarmType: 'Please select alarm type',
      disableChoose: 'You have not selected execution group',
      issueSuc: 'Task assignment success',
      noDevice: 'The current alarm has no device information!',
      noPlan: 'The device has no recording plan!'
    },
    // 标题类
    title: {
      noData: 'No data',
      capPic: 'Capture picture',
      alarmDesc: 'Alarm details',
      alarmDeal: 'Alarm processing',
      confirmAlarm: 'Confirm',
      false: 'False positive',
      taskDelivery: 'Task delivery',
      patrol: 'Video patrol _',
      resourse: 'Resource details',
      device: 'Associated device',
      alarmList: 'List',
      childSys: 'Subsystem',
      alarmInfo: 'Alarm information',
      stop: 'Stop',
      FastBackward: 'FastBackward',
      Speed: 'Speed',
      Multiple: 'Multiple',
      NofullScreen: 'NofullScreen',
      pause: 'Pause',
      NoPlay: 'No video information is playing'
    }
  }
}
